import React from 'react'
import TopNavbar from '../Nav/TopNavbar'
import Footer from '../Sections/Footer'
import Contact from '../Sections/Contact'
import "./contactus.css"

function ContactUs() {
  return (
    <>
        <TopNavbar/>
        <Contact/>
        <Footer/>
    </>
  )
}

export default ContactUs